const phosphate = {
  parameters: [
    {
      name: 'phosphate',
      displayName: 'Phosphate',
      id: 'phosphate',
      validFrom: '2026/04/06 1:00',
      validThrough: null,
      interpretationsSupported: ['normal', 'deficiency', 'high', 'fault'],
      ranges: [
        {
          color: '#6f6b72',
          description: 'phosphate-deficiency',
          lowerLimit: 0,
          lowerLimitOperator: '>=',
          upperLimit: 0.81,
          upperLimitOperator: '<',
          unit: 'mmol/l',
          interpretation: 'deficiency',
          treatAs: 'normal',
          displayInterpretation: 'Deficiency',
        },
        {
          color: '#1f7359',
          description: 'phosphate-normal',
          lowerLimit: 0.81,
          lowerLimitOperator: '>=',
          upperLimit: 1.45,
          upperLimitOperator: '<=',
          unit: 'mmol/l',
          interpretation: 'normal',
          displayInterpretation: 'Normal',
        },
        {
          color: '#f52d0a',
          description: 'phosphate-high',
          lowerLimit: 1.45,
          lowerLimitOperator: '>',
          upperLimit: 5,
          upperLimitOperator: '',
          unit: 'mmol/l',
          interpretation: 'high',
          displayInterpretation: 'High',
        },
      ],
    },
  ],
};

export default phosphate;
